export default class Tab {
  constructor() {
    this.tabs = null;
    this.init();
  }

  init() {
    if (document.querySelectorAll("[data-tab-tgt]") != null) {
      this.tabs = document.querySelectorAll("[data-tab-tgt]");
      this.tabs.forEach((elem) => {
        elem.addEventListener(
          "click",
          () => {
            this.activeIndex(elem);
          },
          false
        );
      });
    }
  }

  activeIndex(tab) {
    this.tabs.forEach((elem) => {
      elem.classList.remove("is-active");
      const data = elem.dataset.tabTgt;
      const tgt = document.querySelector(`[data-tab-area="${data}"]`);
      console.log(tgt);
      tgt.classList.remove("is-active");
    });
    tab.classList.add("is-active");
    const data = tab.dataset.tabTgt;
    const tgt = document.querySelector(`[data-tab-area="${data}"]`);
    tgt.classList.add("is-active");
  }
}
